<template>
    <div>
        <div class="seachHeader ">
            <Navigation :route="navigationRoute"></Navigation>

        </div>
        <div class="usercon">
            <div style="text-align: center;">
                <img class="userPhoto" :src="user.avatar || require('@/assets/images/icon/userImg.png')" width="122" height="122" alt="">
                <Upload @success="UploadChange($event)" />
            </div>
            <div class="userul">
                <div class="userli">
                    <span class="userlabel">身份：</span>
                    <span>{{ user.studentCategory }}</span>
                </div>
                <div class="userli">
                    <span class="userlabel">政治面貌：</span>
                    <span>{{ user.politicalType }}</span>
                </div>
                <div class="userli">
                    <span class="userlabel">学号/职工号：</span>
                    <span>{{ user.studentNum }}</span>
                </div>
                <div class="userli">
                    <span class="userlabel">所在组织：</span>
                    <span>{{ user.company }}</span>
                </div>
                <div class="userli">
                    <span class="userlabel">干部类别：</span>
                    <span>{{ user.type }}</span>
                </div>
            </div>

        </div>

    </div>
</template>

<script>
import Navigation from "@/components/Navigation.vue";
import { mapState, mapMutations } from "vuex";
import { getUser, avatar, upload } from "@/api/user.js";
export default {
    name: "",
    components: {
        Navigation,

    },
    data() {
        return {
            navigationRoute: [
                { name: '个人信息' },
                { name: '基本信息' },
            ],
            user: {

            }
        };
    },
    created() {
        this.getList()
    },
    computed: {

    },
    methods: {

        getList() {
            getUser().then(res => {
                this.user = res
            })
        },

        UploadChange(params) {
            avatar({avatarUrl:params.url}).then(res => {
                this.getList()
            })
        }
    },
};
</script>
<style lang="scss" scoped>
.usercon {
    background: #F6F6F6;
    border-radius: 0px 0px 0px 0px;
    border: 1px solid #D8D8D8;
    padding: 50px;
    width: 400px;
    margin: 50px auto;
}

.userul {
    margin-top: 20px;

    &>.userli:last-child {
        border-bottom: none;
    }

    .userli {
        font-weight: 400;
        font-size: 16px;
        color: #1A1A1A;
        border-bottom: 1px solid #E7E7E7;
        padding: 15px 0;
        display: flex;

        &>span {
            display: block;
        }

        &>span:last-child {
            flex: 1;
        }
    }

    .userlabel {
        color: #767676;
        width: 110px;
        min-width: 110px;
    }
}
.userPhoto{
    border-radius: 50%;
}
</style>